module.exports = __webpack_public_path__ + "img/undraw_privacy_protection_nlwy.f8b14358.svg";